import { put, takeEvery, call } from 'redux-saga/effects';
import { apiConfig } from '../configs/apiConfig.js';
import { postRequest } from '../util/index.js';
import {
    FETCH_ACTIVE_TRAINING_MATERIAL_REQUESTED,
    fetchActiveTrainingMaterialSuccess,
    fetchActiveTrainingMaterialError
} from '../actions/trainingActions.js';

function* fetchActiveTrainingMaterial() {
    try {
        const response = yield call(postRequest, apiConfig.trainingMaterial.endPointUrl, { action: 'getActive' });
        const data = yield response.json();

        if (data.errorCode === 0 && data.data && data.data.downloadUrl) {
            yield put(fetchActiveTrainingMaterialSuccess(data.data));
        } else {
            yield put(fetchActiveTrainingMaterialError('No active training material found'));
        }
    } catch (error) {
        console.error('Error fetching active training material:', error);
        yield put(fetchActiveTrainingMaterialError('Failed to load training material'));
    }
}

function* getActiveTrainingMaterialSaga() {
    yield takeEvery(FETCH_ACTIVE_TRAINING_MATERIAL_REQUESTED, fetchActiveTrainingMaterial);
}

export default getActiveTrainingMaterialSaga;
